<div class="table-wrapper-smaller">
  <div class="table-container">
    <table>
      <thead>
          <tr>
              <th class="icon"></th>
              <th class="icon"></th>
              <th class="id sortable"  (click)="toOrderBy('x=> x.Id', 3)">
                {{'mantenimientoConfecciones.table.id' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Id', 3)"></i>
                </div>
              </th>
              <th class="string sortable" (click)="toOrderBy('x=> x.DenominacionUnica.Des', 4)">
                {{'mantenimientoConfecciones.table.denominacion' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.DenominacionUnica.Des', 4)"></i>
                </div>
              </th>
              <th class="string">{{'mantenimientoConfecciones.table.etiquetador' | translate}}</th>
              <th class="string sortable" (click)="toOrderBy('x=> x.Des', 6)">
                {{'mantenimientoConfecciones.table.confeccion' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Des', 6)"></i>
                </div>
              </th>
              <th class="number sortable" (click)="toOrderBy('x=> x.Kilos', 7)">
                {{'mantenimientoConfecciones.table.peso' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.Kilos', 7)"></i>
                </div>
              </th>
              <th class="number sortable" (click)="toOrderBy('x=> x.NumCajasTotales', 8)">
                {{'mantenimientoConfecciones.table.nCajas' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.NumCajasTotales', 8)"></i>
                </div>
              </th>
              <th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 9)">
                {{'global.fecha.insercionShort' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.fechaIns', 9)"></i>
                </div>
              </th>
              <th class="date sortable" (click)="toOrderBy('x=> x.fechaUpd', 10)">
                {{'global.fecha.actualizacionShort' | translate}}
                <div class="sortable-icons">
                  <i [ngClass]="getIcon('x=> x.fechaUpd', 10)"></i>
                </div>
              </th>
              <th class="action">
                  <i class="fas fa-plus" *ngIf="this.role === 'Administrador' || this.claims.includes('CONF_Ins')"
                      (click)="create()" title="{{'mantenimientoConfecciones.tituloNew' | translate}}"></i>
              </th>
          </tr>
      </thead>
      <tbody *ngFor="let confeccionPallet of _confeccionesPallet; let i = index; trackBy: trackByConfeccionId">
          <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
              <td class="icon">
                  <i *ngIf="!confeccionPallet.activo" class="fas fa-lock" title="{{'titles.confeccionDeshabilitada' | translate}}"></i>
              </td>
              <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
              </td>
              <td class="id">{{confeccionPallet.id}}</td>
              <td class="string">{{confeccionPallet.desDenominacionUnica !== null ? confeccionPallet.desDenominacionUnica : 'Mix' }}</td>
              <td class="string">{{confeccionPallet.desEtiquetador}}</td>
              <td class="string">{{confeccionPallet.des}}</td>
              <td class="number">{{confeccionPallet.kilos | number : '1.2-2': defaultLanguage}}</td>
              <td class="number">{{confeccionPallet.numCajasTotales}}</td>
              <td class="date">{{confeccionPallet.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
              <td class="date">{{confeccionPallet.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
              <td class="multi-actions-bigSubtable">
                  <i class="fas fa-stream" app-click-stop-propagation (click)="openTabs(i)"
                     title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                  <!-- <i class="fa fa-copy" app-click-stop-propagation *ngIf="this.role === 'Administrador' || this.role === 'Etiquetador'"
                      [ngClass]="{'disabled': (!confeccionPallet.denominacionIdUnica || !confeccionPallet.activo || (denominacionesOnFilters && denominacionesOnFilters.length <= 1))}" (click)="duplicarConfeccion(confeccionPallet)"
                      title="{{'titles.duplicarConfeccion' | translate}}"></i> -->
                  <i class="fas fa-pencil-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('CONF_Upd')"
                      app-click-stop-propagation (click)="update(confeccionPallet)" title="{{'titles.editar' | translate}}"></i>
                  <i class="far fa-trash-alt" *ngIf="this.role === 'Administrador' || this.claims.includes('CONF_Del')"
                      [ngClass]="{'disabled': (confeccionPallet.registroEnUso)}" app-click-stop-propagation
                      (click)="askDelete(confeccionPallet)" title="{{'titles.eliminar' | translate}}"></i>
              </td>
          </tr>
          <tr *ngIf="dropdownInfo === i">
            <td colspan="11">
              <div class="detail">
                <div class="title">{{'global.masInformacion' | translate}}</div>
                <div class="block-inline">
                  <label>{{'mantenimientoConfecciones.table.alias' | translate}}</label>
                  <p>
                    {{confeccionPallet.alias}}
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="dropdownSection === i">
              <td colspan="6">
                  <section class="tabs">
                      <ul>
                          <li [ngClass]="{'active': pestanaActiva === 1}" (click)="showEnvases(i)">{{'mantenimientoConfecciones.cajas.titulo' | translate}}</li>
                      </ul>
                      <content>
                          <app-cajas-pallet-list *ngIf="pestanaActiva === 1" [desgloseConfeccionesPallet]="confeccionPallet.lsDesgloseConfPallet"></app-cajas-pallet-list>
                      </content>
                  </section>
              </td>
          </tr>
      </tbody>
      <tfoot *ngIf="!_confeccionesPallet || (_confeccionesPallet && _confeccionesPallet.length < 1)">
          <tr>
              <td colspan="10">
                  {{'global.noContent' | translate}}
              </td>
          </tr>
      </tfoot>
    </table>
  </div>
</div>
<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="newModal">
    <div class="modal-content" id="modal-table">
        <header>
            <h4>{{'mantenimientoConfecciones.tituloNew' | translate}}</h4>
        </header>
        <app-confecciones-pallet-new-component [tipoConfeccion]=2 (refresh)="toRefresh($event)" (mensaje)="pushMessage($event)">
        </app-confecciones-pallet-new-component>
    </div>
</div>
<div class="modal" *ngIf="editModal">
    <div class="modal-content">
        <header>
            <h4>{{'mantenimientoConfecciones.tituloEdit' | translate}}</h4>
        </header>
        <app-confecciones-edit-component [confeccionId]="confeccionPalletId" (refresh)="toRefresh($event)" (mensaje)="pushMessage($event)">
        </app-confecciones-edit-component>
    </div>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
        </header>
        <content>
            <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{ 'global.cancelar' | translate }}</button>
            <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="duplicarModal">
  <div class="modal-content">
    <header>
      <h4>{{'mantenimientoConfecciones.duplicarConfecciones.titulo' | translate}}</h4>
      <i class="fas fa-times" (click)="closeDuplicarModal()"></i>
    </header>
    <div id="filter-modal">
      <content>
        <div class="filters-info">{{'global.infoRequired' | translate}}</div>
        <section class="filters-framed" id="big-modal">
          <form [formGroup]="denominacionesDuplicarForm" [ngClass]="{'show-error': showError}">
            <div class="entry-4-modal" *ngIf="denominacionesDuplicar && denominacionesDuplicar.length == 1">
              <label>{{'mantenimientoConfecciones.duplicarConfecciones.filters.denominacion' | translate}} *</label>
              <app-filterable-list [itemsList]="denominacionesDuplicar" [disabled]="disabledDuplicar" [selectedItem]="denominacionesDuplicarForm.get('denominacionId')" [placeHolder]="false">
              </app-filterable-list>
            </div>
            <div class="entry-4-modal" *ngIf="denominacionesDuplicar && denominacionesDuplicar.length > 1">
              <label>{{'mantenimientoConfecciones.duplicarConfecciones.filters.denominacion' | translate}} *</label>
              <app-multiselect-list [itemsList]="denominacionesDuplicar" (shareCheckedList)="shareCheckedListDenominaciones($event)"
                  [selectedItem]="denominacionesDuplicarForm.get('denominacionesId')"
                  [disabled]="disabledDuplicar" [initialState]="'allSelected'">
              </app-multiselect-list>
            </div>
          </form>
        </section>
        <footer class="button-bar-right">
          <button [disabled]="disableOnDuplicate" [ngClass]="{'secondary-disabled': disableOnDuplicate}"
          (click)="onDuplicate()">{{'mantenimientoConfecciones.duplicarConfecciones.duplicar' | translate}}</button>
        </footer>
      </content>
    </div>
  </div>
</div>
